/**
 *
 * ReceptionView sagas
 *
 */

export default function createReceptionViewSaga(config = {}) { // eslint-disable-line
  return function* rootSaga() {}; // eslint-disable-line
}
